<div class="row">
  <div class="col-12">
    <div class="content-header">Task Form</div>
  </div>
</div>
<!-- Basic Inputs start -->
<section id="basic-input">
  <div class="row">
    <div class="col-12">
      <div class="card">
        <div class="card-content">
          <div class="card-body">
            <div class="row">
              <div class="col-md-6">
                <form [formGroup]="taskForm">
                  <fieldset class="form-group">
                    <label>Lead Type</label>
                    <ng-select
                    [items]="lead_type_List"
                    bindLabel="displayname"
                    bindValue="_id"
                    placeholder="Select Lead Type"
                    [(ngModel)]="selected_leadType"
                    [multiple]="false"
                    [ngModelOptions]="{ standalone: true }"
                    (change)="getChangeLeadType($event)"
                  >
                  </ng-select>
                  </fieldset>
                  <fieldset class="form-group">
                    <label>To</label>
                    <ng-select
                    [items]="usersList"
                    bindLabel="name"
                    bindValue="_id"
                    placeholder="Select Student"
                    [(ngModel)]="selectedUser"
                    [multiple]="true"
                    [ngModelOptions]="{ standalone: true }"
                    (change)="getSelectUserId($event)"
                  >
                  </ng-select>
                  
                  </fieldset>
                  <fieldset class="form-group">
                    <label>Title</label>
                    <input
                      type="text"
                      class="form-control"
                      formControlName="title" [(ngModel)]="task_model.title"
                      placeholder="Enter title"
                      [ngClass]="{
                        'is-invalid':
                          taskFormSubmitted && rf.title.invalid,
                        'is-valid':
                        taskFormSubmitted && !rf.title.invalid
                      }"
                      required
                    #title/>
                    <div
                      *ngIf="
                      rf.title.touched &&
                        (rf.title.invalid ||
                          rf.title.errors?.required)
                      "
                      class="help-block mt-1 text-danger"
                    >
                      <i class="ft-alert-circle align-middle"></i> title
                      is required
                    </div>
                  </fieldset>
                  <fieldset class="form-group">
                    <label>Body</label>
                    <textarea name="" id=""  class="form-control"
                    formControlName="body" [(ngModel)]="task_model.body"
                    placeholder="Enter body" cols="30" rows="2"></textarea>
                  </fieldset>
                  <fieldset class="form-group">
                    <label>Due Date</label>
                    <input
                      type="date"
                      class="form-control"
                      formControlName="due_date" [(ngModel)]="task_model.due_date"
                      placeholder="Enter due date"
                     />
                  </fieldset>
                  <fieldset class="form-group">
                    <label>Task Type</label>
                    <ng-select
                    [items]="task_type_List"
                    bindLabel="displayname"
                    bindValue="_id"
                    placeholder="Select Task"
                    [(ngModel)]="selected_task_type"
                    [ngModelOptions]="{ standalone: true }"
                    (change)="getChangeTaskType($event)"
                  >
                  </ng-select>
                  </fieldset>
                  <fieldset class="form-group">
                    <label>Priority</label>
                    <ng-select
                    [items]="task_priority_List"
                    bindLabel="displayname"
                    bindValue="_id"
                    placeholder="Select Priority"
                    [(ngModel)]="selected_task_priority"
                    [ngModelOptions]="{ standalone: true }"
                    (change)="getChangeTaskPriority($event)"
                  >
                  </ng-select>
                  </fieldset>
                  <fieldset class="form-group">
                    <label>Task Label</label>
                    <ng-select
                    [items]="task_label_List"
                    bindLabel="displayname"
                    bindValue="_id"
                    placeholder="Select Task label"
                    [(ngModel)]="selected_task_label"
                    [ngModelOptions]="{ standalone: true }"
                    (change)="getChangeTaskLabel($event)"
                  >
                  </ng-select>
                  </fieldset>
                </form>
              </div>
              <div class="col-md-6">
                <form [formGroup]="taskForm">
              
                  <fieldset class="form-group">
                    <label>Is Schedule</label>
                    <ng-select
                    [items]="schedule_List"
                    bindLabel="name"
                    bindValue="id"
                    placeholder="Select One"
                    [(ngModel)]="selected_schedule"
                    [ngModelOptions]="{ standalone: true }"
                    (change)="getChangeScheduleId($event)"
                  >
                  </ng-select>
                  </fieldset>
                  <fieldset class="form-group">
                    <label>Schedule Duration</label>
                    <input
                      type="datetime-local"
                      class="form-control"
                      formControlName="scheduleduration" [(ngModel)]="task_model.scheduleduration"
                    />
                  </fieldset>
                  <fieldset class="form-group">
                    <label>Working Hours</label>
                    <input
                      type="number"
                      class="form-control"
                      formControlName="working_hours" [(ngModel)]="task_model.working_hours"
                    />
                  </fieldset>
                  <fieldset class="form-group">
                    <label>Mandatory</label>
                    <ng-select
                    [items]="mandatory_List"
                    bindLabel="name"
                    bindValue="id"
                    placeholder="Select One"
                    [(ngModel)]="selected_mandatory"
                    [ngModelOptions]="{ standalone: true }"
                    (change)="getChangeMandatoryId($event)"
                  >
                  </ng-select>
                  </fieldset>
                  <fieldset class="form-group">
                    <label>Budget</label>
                    <input
                      type="text"
                      class="form-control"
                      formControlName="budget" [(ngModel)]="task_model.budget"
                      placeholder="Enter budget" 
                    />
                  </fieldset>
                  <fieldset class="form-group">
                    <label>Stage</label>
                    <ng-select
                    [items]="task_stage_List"
                    bindLabel="displayname"
                    bindValue="_id"
                    placeholder="Select Stage"
                    [(ngModel)]="selected_task_stage"
                    [ngModelOptions]="{ standalone: true }"
                    (change)="getChangeTaskStage($event)"
                  >
                  </ng-select>
                  </fieldset>
                  <fieldset class="form-group">
                    <label>Notes</label>
                    <textarea name="" class="form-control" placeholder="Enter notes"
                    formControlName="notes" [(ngModel)]="task_model.notes"
                     id="" cols="30" rows="1"></textarea>
                  </fieldset>
                  <fieldset class="form-group">
                    <label>Admin Notes</label>
                    <textarea name="" class="form-control" placeholder="Enter admin notes"
                    formControlName="admin_notes" [(ngModel)]="task_model.admin_notes"
                     id="" cols="30" rows="1"></textarea>
                  </fieldset>
                  <div
                  class="col-12 d-flex flex-sm-row flex-column justify-content-end mt-3 mt-sm-2"
                >
                  <button
                    type="submit"
                    class="btn btn-primary mb-2 mb-sm-0 mr-sm-2"
                    (click)="submit()"
                  >
                    Submit
                  </button>
                  <button
                    type="reset"
                    class="btn btn-secondary"
                    (click)="back()"
                  >
                    Cancel
                  </button>
                </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
